import React from 'react'
import { Grid } from '@material-ui/core'
import Typo from '../../components/CustomTypo'
import { domainName } from '../../../portal.config'
import { portalCfg, navigate } from '../../../portal.router.config'
import { withStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import CustomizedCircularProgress from '../../components/CircularProgress'
import InfiniteScroll from 'react-infinite-scroll-component'
import { GiftIcon } from '../../components/icons'
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil'

const heightCoverItem = 180
const heightContentItem = 140

const styles = theme => ({
    container: {
        padding: theme.spacing(3),
        cursor: 'pointer',
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 2, 1, 2),
        },
    },
    item: {
        border: '0px solid',
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        //height: 280,
        //backgroundColor: theme.palette.background.secondary,
        position: 'relative',
    },
    image_container: {
        height: heightCoverItem + heightContentItem,
    },
    item_cover: {
        width: '100%',
        height: heightCoverItem + heightContentItem,
        objectFit: 'cover',
        borderRadius: theme.spacing(4),
    },
    item_content: {
        padding: theme.spacing(6,4,4,4),
        backgroundColor: theme.palette.background.secondary,
        borderBottomLeftRadius: theme.spacing(4),
        borderBottomRightRadius: theme.spacing(4),
        //height: heightContentItem,
        width:'100%',
        position: 'absolute',
        bottom: 0,
    },
});

function PromotionsView(props) {
    const { classes, t, promotions, onShowDetailPromotion, showLoading } = props;
    console.log("promotions===", promotions);

    return (
        <Grid item xs={12}>
            <Typo mg_left_md variant='caption1' light>{t('order_promotion')}</Typo>
            {showLoading && <Grid xs={12} item container justify='center'>
                <CustomizedCircularProgress />
            </Grid>}
            <Grid xs={12} item container className={classes.margin}>
                {promotions.map((item, index) => (
                    <PromotionItem t={t} classes={classes}
                        key={index}
                        item={item}
                        onShowPromotionDetail={onShowDetailPromotion}
                    />
                ))}
            </Grid>
        </Grid>
    );
}

function PromotionItem(props) {
    const { t, classes, item } = props;
    return (
        <Grid item xs={12} sm={6} md={6} lg={4} xl={3} className={classes.container} onClick={() => props.onShowPromotionDetail(item)} data-promotion-id={item.id} data-promotion-name={item.name}>
            <Grid item xs={12} className={classes.item}>
                <Grid item container xs={12} justify='center' className={classes.image_container}>
                    <PromotionItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.offer_detail)} />
                </Grid>
                <Grid item xs={12} className={classes.item_content}>
                    <Typo variant="body1">{item.name}</Typo>
                </Grid>
            </Grid>
        </Grid>
    );
}

function PromotionItemImage(props) {
    const { classes, creatives, image } = props;

    if (image) {
        return <img src={image.url} className={classes.item_cover} />
    } else {
        return (
            <Grid item xs={12} container alignItems='center' justify='center' className={classes.item_cover} >
                <GiftIcon />
            </Grid>
        )
    }
}

export default withStyles(styles)(withTranslation()(PromotionsView));